"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const LoggerContext_1 = require("../../../lib/LoggerContext");
const types_1 = require("../types");
const ActivityContent_1 = require("./ActivityContent");
const InsightsActivityContent_1 = require("./InsightsActivityContent");
const InsightsFeedTypes = [
    types_1.ActivityType.DeviationInsight,
    types_1.ActivityType.DeviationRiskInsight,
    types_1.ActivityType.ReassuranceInsight,
    types_1.ActivityType.UpdateInsight,
];
const InsightDisplayContent = ({ feed }) => {
    const { current } = (0, frontend_infra_localisation_1.useI18n)();
    const { logError } = (0, LoggerContext_1.useLoggerContext)();
    const renderedContent = feed.activity?.customField?.['renderedContent'];
    if (renderedContent && renderedContent?.[current]) {
        return (0, jsx_runtime_1.jsx)(InsightsActivityContent_1.InsightsActivityContent, { feed: feed });
    }
    logError('[Content Outdated] Not able to render the insight activity');
    return null;
};
const GenericActivity = ({ feed, isForCustomer }) => {
    const { activity } = feed;
    const isInsight = InsightsFeedTypes.indexOf(activity.type) > -1;
    return ((0, jsx_runtime_1.jsx)("div", { "data-e2e-id": "chat_message-text", children: isInsight ? ((0, jsx_runtime_1.jsx)(InsightDisplayContent, { feed: feed })) : ((0, jsx_runtime_1.jsx)(ActivityContent_1.ActivityContent, { feed: feed, isForCustomer: isForCustomer ?? false })) }));
};
exports.GenericActivity = GenericActivity;
//# sourceMappingURL=GenericActivity.js.map